import SearchFoodResults from "components/search/SearchFoodResults"
import SuggestedSearchTexts from "components/search/SuggestedSearchTexts"
import { ISearchFoodOverlayDisplaySection } from "features/food/foodSlice.types"
import {
  useSearchFoodOverlayDisplaySection,
  useSearchFoods,
  useSuggestedSearchTexts,
} from "features/food/hooks"
import { useEffect } from "react"
import { SearchFoodOverlayWrapper, SearchInputBox, StyledMask } from "./styled"
import SearchAutocomplete from "components/search/SearchAutocomplete"
import { SearchFoodResultType } from "model/food/types"

const { AUTOCOMPLETE, SEARCH_RESULTS } = ISearchFoodOverlayDisplaySection

interface IProps {
  onAdd: (food: SearchFoodResultType) => void
  onSelect: (food: SearchFoodResultType) => void
  visible: boolean
  onClose: () => void
  hasCreateLink?: boolean
  hideAddBtn?: boolean
}

const SearchFoodOverlay = (props: IProps) => {
  const { onAdd, onSelect, visible, onClose, hasCreateLink, hideAddBtn } = props

  const {
    searchFoodOverlayDisplaySection: displaySection,
    setSearchFoodOverlayDisplaySection: setDisplaySection,
  } = useSearchFoodOverlayDisplaySection()

  useEffect(() => {
    if (visible) {
    }
  }, [visible])

  const {
    keyword,
    suggestedSearchTexts,
    handleKeywordChange,
    isNoSuggestedSearchTexts,
  } = useSuggestedSearchTexts()

  const {
    searchFoodsResults,
    handleSearchFoods,
    searchFoodsLoading,
    searchSession,
    noSearchedFoodFounded,
  } = useSearchFoods()

  return (
    <StyledMask visible={visible}>
      <SearchFoodOverlayWrapper>
        <SearchInputBox>
          <SearchAutocomplete
            visible={visible}
            onFocus={() => {}}
            placeholder="Search"
            value={keyword}
            onChange={(keyword) => {
              handleKeywordChange(keyword)
              if (displaySection !== AUTOCOMPLETE) {
                setDisplaySection(AUTOCOMPLETE)
              }
            }}
            onClose={() => {
              handleKeywordChange("")
              onClose()
            }}
            onBlur={() => {}}
            onSearch={() => {
              const forceReset = true
              handleSearchFoods({ nextKeyword: keyword, forceReset })
              setDisplaySection(SEARCH_RESULTS)
            }}
          />
        </SearchInputBox>

        {displaySection === AUTOCOMPLETE && (
          <div style={{ padding: "0 var(--app-horizontal-padding)" }}>
            <SuggestedSearchTexts
              isNoSuggestedSearchTexts={isNoSuggestedSearchTexts}
              suggestedTexts={suggestedSearchTexts}
              keyword={keyword}
              onSelect={(keyword) => {
                const forceReset = true
                handleSearchFoods({ nextKeyword: keyword, forceReset })
                setDisplaySection(SEARCH_RESULTS)
              }}
            />
          </div>
        )}

        {displaySection === SEARCH_RESULTS && (
          <SearchFoodResults
            onAddFood={onAdd}
            onSelectFood={onSelect}
            noSearchedFoodFounded={noSearchedFoodFounded}
            foods={searchFoodsResults}
            onLoad={() => handleSearchFoods({ nextKeyword: keyword })}
            loading={searchFoodsLoading}
            hasMore={!!searchSession}
            keyword={keyword}
            hasCreateLink={hasCreateLink}
            hideAddBtn={hideAddBtn}
          />
        )}
      </SearchFoodOverlayWrapper>
    </StyledMask>
  )
}

export default SearchFoodOverlay
